export default [
    'shortcode',
    'stethoscope',
    'alarm-clock',
    'cloudnetwork',
    'angle-double-down',
    'highlight-alt',
    'alarm',
    'certificate',
    'bootstrap',
    'google',
    'briefcase',
    'stamp',
    'stats-up',
    'plane',
    'git',
    'mouse',
    'grow',
    'cloud-sync',
    'display',
    'protection',
    'arrow-up-circle',
    'star-half',
    'chevron-left',
    'skype',
    'shield',
    'underline',
    'smile',
    'files',
    'search',
    'caravan',
    'pointer-down',
    'syringe',
    'text-allign-right',
    'cloud-check',
    'facebook-original',
    'dinner',
    'amazon-original',
    'layout',
    'ruler-alt',
    'frame-expand',
    'book',
    'target-audience',
    'pointer-right',
    'slim',
    'eraser',
    'twitch',
    'html',
    'nextcloud',
    '500px',
    'helmet',
    'thunder-alt',
    'sun',
    'coffee-cup',
    'stop',
    'download',
    'reload',
    'write',
    'night',
    'basketball',
    'linkedin-filled',
    'cross-circle',
    'lock',
    'thumbs-up',
    'mastercard',
    'brush-alt',
    'zoom-out',
    'offer',
    'indent-decrease',
    'spell-check',
    'bubble',
    'dropbox',
    'cart-full',
    'map',
    'cut',
    'vk',
    'teabag',
    'money-protection',
    'twitter-filled',
    'code-alt',
    'instagram-original',
    'rocket',
    'tounge',
    'sort-amount-asc',
    'star',
    'slack',
    'tag',
    'invest-monitor',
    'pyramids',
    'seo-consulting',
    'trees',
    'dollar',
    'bookmark-alt',
    'flower',
    'facebook',
    'pin-alt',
    'ticket',
    'comments',
    'target-revenue',
    'mashroom',
    'google-plus-original',
    'whatsapp',
    'italic',
    'warning-high',
    'phone-handset',
    'arrow-right',
    'facebook-filled',
    'shift-left',
    'download-complete',
    'rupee',
    'bridge',
    'train-alt',
    'shift-right',
    'contrast',
    'paypal-original',
    'snapchat',
    'candy',
    'world',
    'funnel',
    'instagram',
    'surfboard',
    't-shirt',
    'bolt',
    'more-filled',
    'flickr',
    'weight',
    'cloud',
    'edit-permission',
    'direction',
    'pointer-left',
    'camera',
    'seo-monitoring',
    'twitter-original',
    'pin',
    'clipboard',
    'tree',
    'share',
    'wheelbarrow',
    'burger',
    'text-allign-left',
    'home',
    'rss-feed',
    'diamond',
    'scroll-down',
    'medall-alt',
    'customer',
    'key',
    'behance-original',
    'amex',
    'bluetooth',
    'cart',
    'edit-pencil',
    'calculator',
    'tab',
    'cog',
    'road',
    'drupal-original',
    'behance',
    'sad',
    'zip',
    'arrow-left',
    'stripe',
    'car-alt',
    'shuffle',
    'revenue',
    'chevron-up',
    'postcard',
    'android',
    'euro',
    'school-bench-alt',
    'credit-cards',
    'thumbs-down',
    'na',
    'facebook-messenger',
    'school-bench',
    'laptop-phone',
    'dropbox-original',
    'flag',
    'ambulance',
    'train',
    'bar-chart',
    'wheelchair',
    'circle-minus',
    'checkmark-circle',
    'scooter',
    'folder',
    'crown',
    'menu-dots',
    'bulb',
    'question-circle',
    'music',
    'arrow-down-circle',
    'happy',
    'infinite',
    'text-allign-center',
    'bug',
    'arrow-top-left',
    'exit-down',
    'upload',
    'library',
    'pie-chart',
    'school-compass',
    'mobile',
    'island',
    'spinner-arrow',
    'text-size',
    'vector',
    'domain',
    'zoom-in',
    'undo',
    'agenda',
    'blogger',
    'joomla',
    'open-new-window',
    'line-double',
    'unlink',
    'pagination',
    'grid-alt',
    'information',
    'pulse',
    'close',
    'drupal',
    'text-allign-justify',
    'unlock',
    'investment',
    'power-switch',
    'skipping-rope',
    'line-spacing',
    'brick',
    'bi-cycle',
    'send-diagonal',
    'github',
    'notepad',
    'chevron-down-circle',
    'save',
    'candy-cane',
    'vimeo',
    'chevron-right',
    'dribbble',
    'service',
    'empty-file',
    'inbox',
    'wallet',
    'minus',
    'cup',
    'spotify-original',
    'layers',
    'reply',
    'remove-file',
    'restaurant',
    'chef-hat',
    'volume-medium',
    'share2',
    'black-board',
    'yen',
    'text-format',
    'eye',
    'first-aid',
    'plug',
    'ycombinator',
    'mute',
    'keyword-research',
    'arrow-top-right',
    'network',
    'quotation',
    'yahoo',
    'ruler',
    'travel',
    'friendly',
    'thought',
    'exit',
    'producthunt',
    'flags',
    'standard',
    'bitbucket',
    'wechat',
    'volume',
    'play',
    'ux',
    'arrows-vertical',
    'more',
    'exit-up',
    'stackoverflow',
    'ship',
    'delete-selection',
    'arrow-down',
    'line-dashed',
    'slice',
    'signal',
    'medall',
    'magnet',
    'pencil-alt',
    'ticketalt',
    'mic',
    'pilcrow',
    'cloud-download',
    'pinterest',
    'hospital',
    'coin',
    'thunder',
    'wide',
    'sprout',
    'paper-clip',
    'printer',
    'move',
    'indent-increase',
    'target',
    'instagram-filled',
    'brush',
    'shopify',
    'dumbbell',
    'wordpress-filled',
    'archive',
    'java',
    'pizza',
    'telegram',
    'envato',
    'pound',
    'soundcloud',
    'rain',
    'fireworks',
    'taxi',
    'arrow-left-circle',
    'spinner',
    'licencse',
    'page-break',
    'bookmark',
    'timer',
    'warning',
    'database',
    'code',
    'apple',
    'comments-reply',
    'angle-double-up',
    'money-location',
    'linkedin-original',
    'help',
    'dashboard',
    'microscope',
    'pointer',
    'microsoft',
    'lineicons-alt',
    'construction',
    'headphone-alt',
    'list',
    'paint-bucket',
    'shovel',
    'source_icons_eye-off',
    'visa',
    'trash',
    'users',
    'megento',
    'headphone',
    'radio-button',
    'user',
    'source_icons_eye-empty',
    'capsule',
    'menu',
    'cloudy-sun',
    'chrome',
    'construction-hammer',
    'bolt-alt',
    'android-original',
    'package',
    'star-filled',
    'backward',
    'apartment',
    'paint-roller',
    'harddrive',
    'heart-monitor',
    'seo',
    'display-alt',
    'windows',
    'heart',
    'ruler-pencil',
    'website',
    'lineicons-original',
    'chevron-left-circle',
    'spray',
    'sort-alpha-asc',
    'direction-alt',
    'add-file',
    'popup',
    'line-dotted',
    'direction-rtl',
    'bullhorn',
    'steam',
    'delivery',
    'suspect',
    'cool',
    'direction-ltr',
    'forward',
    'select',
    'shopping-basket',
    'source_icons_align-justify',
    'star-empty',
    'video',
    'arrows-horizontal',
    'image',
    'pointer-up',
    'map-marker',
    'linkedin',
    'github-original',
    'comments-alt',
    'medium',
    'highlight',
    'angle-double-right',
    'chevron-down',
    'bus-alt',
    'game',
    'reddit',
    'strikethrough',
    'link',
    'volume-high',
    'cloud-upload',
    'keyboard',
    'helicopter',
    'hammer',
    'enter',
    'full screen',
    'plus',
    'pencil',
    'arrow-up',
    'twitter',
    'spinner-arrow-mirrored',
    'bus',
    'wordpress',
    'phone',
    'gallery',
    'souncloud-original',
    'hourglass',
    'firefox',
    'line',
    'graduation',
    'chevron-right-circle',
    'panel',
    'spotify',
    'information-circle',
    'text-format-remove',
    'hand',
    'car',
    'baloon',
    'trowel',
    'invention',
    'checkmark',
    'anchor',
    'quora',
    'fresh-juice',
    'drop',
    'cake',
    'pallet',
    'laptop',
    'slideshare',
    'bold',
    'angle-double-left',
    'gift',
    'playstore',
    'bitcoin',
    'envelope',
    'lineicons',
    'pause',
    'leaf',
    'chevron-up-circle',
    'css',
    'volume-low',
    'iconoir_settings',
    'support',
    'neutral',
    'microphone',
    'heart-filled',
    'paypal',
    'handshake',
    'stats-down',
    'grid',
    'youtube',
    'juice',
    'amazon',
    'crop',
    'spinner-solid',
    'arrow-right-circle',
    'checkbox',
    'share-alt',
    'calendar',
    'magnifier',
];
